export default __webpack_public_path__ + "static/media/account-detail.4121a2bb.svg";